import { create } from 'zustand';
import { GameState, CharacterCustomization } from '@/types/game';

interface GameStore extends GameState {
  setScreen: (screen: GameState['screen']) => void;
  setCharacter: (character: CharacterCustomization) => void;
}

export const useGameStore = create<GameStore>((set) => ({
  screen: 'title',
  character: undefined,
  setScreen: (screen) => set({ screen }),
  setCharacter: (character) => set({ character }),
}));
